import type { TTextInputType } from '@frontend/pole-ui/lib/components/TextInput'
import type { ValidationErrors } from 'final-form'

export interface IFeedbackFormValues {
  fullName: string
  email: string
  phone: string
  message: string
  agreement: boolean
}

export enum EFieldName {
  fullName = 'fullName',
  phone = 'phone',
  email = 'email',
  organization = 'organization',
  message = 'message',
}

export interface IFeedbackFormField {
  fieldName: EFieldName
  type?: TTextInputType
  isFieldRequired?: (errors: ValidationErrors, values: IFeedbackFormValues) => boolean
}

export interface IFeedbackResponse {
  id: number
  fullName: string
  phone: string
  email: string
  inn?: string
  agreement: boolean
  createDate: string
  subject?: string
  text: string
  status: string
}
